import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

import '../../styles/pages.css';
import '../../styles/layout.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="notFoundShell">
      <div className="notFoundShell__card">
        <div className="notFoundShell__badge">404</div>
        <h1 className="notFoundShell__title">Page not found</h1>
        <p className="notFoundShell__text">
          We couldn&apos;t find the workspace you were looking for. Check the URL or return to your
          dashboard.
        </p>
        <div className="notFoundShell__actions">
          <Button
            label="Back to dashboard"
            className="notFoundShell__primaryBtn"
            onClick={() => navigate('/dashboard')}
          />
          <Button
            label="Sign in"
            className="p-button-text notFoundShell__secondaryBtn"
            onClick={() => navigate('/')}
          />
        </div>
      </div>
    </div>
  );
}
